import { AuthConstants } from "./AuthConstants";
import HrbCasAuth from "hrb-cas-auth-js";
import { ConfigConstants } from "./ConfigConstants";
import logger from "../../../utils/logger";

class Auth {
    authProvider = null;

    initProvider = (authConfig) => {
        this.initAuthProvider(authConfig);
    };

    initAuthProvider = (authConfig) => {
        const casDomain = authConfig[ConfigConstants.CAS_SERVICE_URL];
        const casClientId = authConfig[ConfigConstants.CAS_CLIENT_ID];
        const clientOrigin = window.location.origin;

        this.authProvider = new HrbCasAuth({
            namespace: AuthConstants.CAS_NAMESPACE,
            domain: casDomain,
            issuer: casDomain + "/oidc",
            clientId: casClientId,
            clientOrigin,
            loginCallbackUrl: `${clientOrigin}/callback`,
            logoutCallbackUrl: `${clientOrigin}/logout`,
            otcLoginCallbackUrl: `${clientOrigin}/otcCallback`,
            otcClientId: "OneTimeCode",
            responseType: "id_token token",
            scope: "openid profile profile_hrbAuth"
        });
    };

    login = (language) => {
        if (this.authProvider) {
            sessionStorage.setItem("visitedPageName", window.location.pathname);
            localStorage.clear();
            this.authProvider.login(language);
        }
    };

    silentAuthentication = (callback) => {
        const ttl = this.getTokenTimeToLive();
        const t0 = performance.now();

        sessionStorage.setItem("visitedPageName", window.location.pathname);
        this.authProvider.authenticateSilently((result, err) => {
            const t1 = performance.now();
            const authDuration = (t1 - t0) / 1000;

            if (result) {
                logger.addPageAction("AuthService:silentAuthentication", {
                    error: null,
                    errorDescription: null,
                    ttl,
                    authDuration
                });
                callback();
            } else if (err) {
                logger.addPageAction("AuthService:silentAuthentication", {
                    error: err.error,
                    errorDescription: err.errorDescription,
                    tokenTimeToLive: ttl,
                    authDuration: authDuration
                });
                const opts = callback();
                this.login(opts.language);
            }
        }, 60000);
    };

    otcAuthentication = (code, userName) => {
        return new Promise((resolve, reject) => {
            this.authProvider.authenticateOtc(
                (result, err) => {
                    if (result) {
                        resolve(result);
                        logger.addPageAction("AuthService:otcAuthentication from Auth.js", {
                            error: null,
                            errorDescription: null
                        });
                    } else if (err) {
                        logger.addPageAction("AuthService:otcAuthentication from Auth.js", {
                            error: err.error,
                            errorDescription: err.errorDescription
                        });
                        reject(err);
                    }
                },
                code,
                userName
            );
        });
    };

    passUserNameToCas = (userName) => {
        return new Promise((resolve, reject) => {
            this.authProvider.passUserName((result, err) => {
                if (result) {
                    resolve(result);
                } else if (err) {
                    logger.addPageAction("AuthService:passUserNameToCas from Auth.js", {
                        error: err.error,
                        errorDescription: err.errorDescription
                    });
                    reject(err);
                }
            }, userName);
        });
    };

    handleAuthentication = (cb) => {
        return new Promise((resolve, reject) => {
            console.log(this.authProvider)
            this.authProvider.handleAuthenticationResponse((authResult, err) => {
                if (authResult) {
                    logger.addPageAction("AuthService", {
                        error: null,
                        errorDescription: null,
                        result: "authentication success"
                    });
                    resolve(authResult);
                } else if (err) {
                    logger.addPageAction("AuthService", {
                        error: err.error,
                        errorDescription: err.errorDescription,
                        result: "authentication failed"
                    });
                    logger.noticeError(`AuthService: Silent authentication refresh failed (${err.error}, ${err.errorDescription}).`);
                    reject(err);
                }
                resolve();
            });
        });
    };

    logout = () => {
        this.authProvider.logout();
    };

    getAccessToken = () => {
        const accessToken = this.authProvider.getToken();
        if (!accessToken) {
            throw new Error("No access token found");
        }
        return accessToken;
    };

    getProfile = () => {
        if (this.authProvider && this.isAuthenticated()) {
            return this.authProvider.getUserProfile();
        }
        return {};
    };

    getTokenTimeToLive = () => {
        return this.authProvider.getTokenTimeToLive();
    };

    isAuthenticated = () => {
        if (this.authProvider) {
            return this.authProvider.isAuthenticated();
        }
        return false;
    };

    isRegularAuthentication = (authResult) => {
        return authResult.authType === this.authProvider.AUTH_TYPES.REGULAR;
    };

    isSilentAuthentication = (authResult) => {
        return authResult.authType === this.authProvider.AUTH_TYPES.SILENT;
    };
}

const auth = new Auth();
export default auth;
